import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
interface IProps {
  color?: string;
  size?: number;
}
const DefaultOffers = ({color = '#21AD5A', size = 28}: IProps) => (
  <Svg width={size} height={size} viewBox="0 0 28 28" fill="none">
    <Path
      d="M2 4.37541V12.5512C2 13.4809 2.36799 14.3723 3.02708 15.0285L12.6938 24.6535C14.0669 26.0207 16.2913 26.0207 17.6644 24.6535L24.9968 17.3528C26.3699 15.9856 26.3699 13.7707 24.9968 12.4035L15.3301 2.77853C14.671 2.12228 13.7758 1.75588 12.842 1.75588H4.63636C3.18087 1.75041 2 2.92619 2 4.37541ZM8.15152 6.12541C8.61765 6.12541 9.0647 6.30978 9.39431 6.63797C9.72392 6.96616 9.90909 7.41128 9.90909 7.87541C9.90909 8.33954 9.72392 8.78466 9.39431 9.11285C9.0647 9.44103 8.61765 9.62541 8.15152 9.62541C7.68538 9.62541 7.23833 9.44103 6.90872 9.11285C6.57911 8.78466 6.39394 8.33954 6.39394 7.87541C6.39394 7.41128 6.57911 6.96616 6.90872 6.63797C7.23833 6.30978 7.68538 6.12541 8.15152 6.12541Z"
      fill={color}
    />
  </Svg>
);
export default DefaultOffers;
